import triggersActions from '@/store/triggers/actions'
import userActions from '@/store/users/actions'
import statisticsActions from '@/store/statistics/actions'

export default {
    ...userActions,
    ...triggersActions,
    ...statisticsActions
}
